var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"text","icon":"el-icon-download","loading":_vm.loading,"size":"mini"},on:{"click":_vm.exportForm}},[_vm._v("导出表格")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }